import ComponentWithError from './ComponentWithError';

export default ComponentWithError;
